// this is an autogenerated file from App/Account/Content/Settings/Content/Onboarding/mutation.graphql
import { gql } from 'Data/Api'

export default gql`
mutation app__App_Account_Content_Settings_Content_Onboarding(
  $type: onboarding_input_types_enum!
  $inputs_url: String!
) {
  insert_onboarding_inputs_one(
    object: { type: $type, inputs_url: $inputs_url }
  ) {
    id
  }
}

`